const windowSupportsTouchEvents = ('ontouchstart' in window)

export default windowSupportsTouchEvents
